export const de = {
    "BACK_BUTTON": "Zurück",
    "NEXT_BUTTON": "Weiter",
    "FINISH_BUTTON": "Fertig",
    "CHOICES_TITLE": "Auswahl",
    "SELECT_INPUT": "Auswählen",
    "MULTICHOICE_PEER_PLACEHOLDER": "Person(en) auswaehlen",
    "MULTICHOICE_PEER_REQUIRED_ERROR": "Waehlen Sie mindestens eine Person aus.",
    "MULTICHOICE_OTHER_LABEL": "Sonstiges (bitte angeben)",
    "MULTICHOICE_OTHER_PLACEHOLDER": "Bitte angeben",
    "MULTICHOICE_OTHER_TEXT_REQUIRED": "Bitte geben Sie Ihre Antwort fuer \"Sonstiges\" an.",
    "MULTICHOICE_OTHER_TEXT_TOO_LONG": "Ihre Antwort darf hoechstens 1000 Zeichen lang sein.",
    "MULTICHOICE_CLEAR_SELECTION": "Auswahl aufheben",
    "LIKERT_HINT": "Wählen Sie eine Person aus und vergeben Sie eine Bewertung.",
    "LIKERT_SCORE_LABEL": "Bewertung",
    "LIKERT_INCOMPLETE_ERROR": "Wählen Sie in jeder Zeile Person und Bewertung.",
    "LIKERT_INVALID_ERROR": "Eine oder mehrere Bewertungen liegen außerhalb des erlaubten Bereichs.",
    "EMPTY_ERROR": "Pflichtfeld",
        "SUBMIT_ERROR": "Antworten konnten nicht gesendet werden. Bitte Eingaben pruefen.",
    "SENDING_DATA": "Daten werden gesendet...",
    "LOADING": "Laden...",
    "MAX_SELECT_ERROR": "Maximal ausgewählt ist:",
    "FORM_ALREADY_ANSWERED": "Danke für Ihre Antwort!",
    "THANK_YOU": "Danke!",
    "MAX_SELECT_CUSTOM_MESSAGE": "Sie haben den maximalen Optionswert erreicht",
    "SKILL_PLACEHOLDER": "Fähigkeitsstufe",
    "QR_SELECT_TITLE": "Wählen Sie Ihren Namen",
    "QR_SELECT_PLACEHOLDER": "Suchen Sie Ihren Namen...",
    "QR_NO_PARTICIPANTS": "Keine Teilnehmer verfügbar. Alle Teilnehmer haben bereits geantwortet.",
    "QR_SURVEY_NOT_FOUND": "Umfrage nicht gefunden",
    "QR_LOAD_ERROR": "Teilnehmer konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "QR_PARTICIPANT_ALREADY_ANSWERED": "Dieser Teilnehmer hat die Umfrage bereits abgeschlossen. Bitte wählen Sie Ihren Namen erneut.",
    "QR_BACK_TO_SELECTION": "Zurück zur Namensauswahl",
    "companyValues": {
        "PASSION": "Leidenschaft für alles, was wir tun",
        "INNOVATING": "Immer innovativ",
        "CONFIDENCE": "Mit Vertrauen und Verantwortung",
        "WINNING": "Gewinnen als Team",
        "DIFFERENCE": "Engagiert, einen Unterschied zu machen"
    }
}